import { TIER_COLORS, PARAMETER_NAMES, TIER_PARAMETERS, TIER_INFO, getGrade, calculateTierScore, TierGauge, Badge, CTATeaser, badgeColors } from "./DashboardShared";

// =====================================================
// TAB: KEY METRICS
// =====================================================
const KeyMetricsTab = ({ scores, tierScores, onTabChange }) => (
  <div>
    <div className="print-section-title">Key Metrics</div>
    {[1, 2, 3].map(tier => {
      const tierColor = TIER_COLORS[tier];
      const tierInfo = TIER_INFO[tier];
      const tierScore = tierScores[tier] || 0;
      const tierGrade = getGrade(tierScore, 100);
      const params = TIER_PARAMETERS[tier];
      
      return (
        <div key={tier}>
          {/* Desktop Layout */}
          <div className="tier-card-desktop" style={{ background: "#FFFFFF", border: "1px solid rgba(10,10,26,0.08)", borderRadius: 14, padding: 22, marginBottom: 12, position: "relative", overflow: "hidden", gap: 16, alignItems: "center" }}>
            <div style={{ position: "absolute", top: 0, left: 0, bottom: 0, width: 3, background: tierColor }} />
            <TierGauge score={tierScore} color={tierColor} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 2 }}>
                <span style={{ fontFamily: "'Outfit', sans-serif", fontSize: 15, fontWeight: 700, color: "#0A0A1A" }}>{tierInfo.name}</span>
                <Badge grade={tierGrade} />
              </div>
              <div style={{ fontSize: 11.5, color: "rgba(10,10,26,0.4)", marginBottom: 14 }}>{tierInfo.question}</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
                {params.map(param => {
                  const paramScore = Math.round(scores[param] || 0);
                  const paramGrade = getGrade(paramScore);
                  return (
                    <div key={param}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 3 }}>
                        <span style={{ fontSize: 11, fontWeight: 500, color: "rgba(10,10,26,0.5)" }}>{PARAMETER_NAMES[param]}</span>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <span style={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, fontWeight: 700, color: tierColor }}>{paramScore}/10</span>
                          <Badge grade={paramGrade} small />
                        </div>
                      </div>
                      <div style={{ height: 4, background: "rgba(10,10,26,0.05)", borderRadius: 2, overflow: "hidden", maxWidth: "60%" }}>
                        <div style={{ height: "100%", width: `${paramScore * 10}%`, background: tierColor, borderRadius: 2 }} />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          
          {/* Mobile Layout - Gauge + Clean Rows */}
          <div className="tier-card-mobile" style={{ background: "#FFFFFF", border: "1px solid rgba(10,10,26,0.08)", borderLeft: `3px solid ${tierColor}`, borderRadius: 14, marginBottom: 12, overflow: "hidden" }}>
            <div style={{ padding: "16px 18px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid rgba(10,10,26,0.05)" }}>
              <div style={{ position: "relative", width: 64, height: 64, flexShrink: 0 }}>
                <svg width="64" height="64" viewBox="0 0 64 64" style={{ position: "absolute", top: 0, left: 0 }}>
                  <circle cx="32" cy="32" r="26" fill="none" stroke="rgba(10,10,26,0.06)" strokeWidth="5"/>
                  <circle cx="32" cy="32" r="26" fill="none" stroke={badgeColors[tierGrade.class].background} strokeWidth="5"
                    strokeDasharray="163.4"
                    strokeDashoffset={163.4 - (tierScore / 100) * 163.4}
                    strokeLinecap="round" transform="rotate(-90 32 32)"/>
                </svg>
                <div style={{ position: "absolute", top: 0, left: 0, width: 64, height: 64, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                  <span style={{ fontFamily: "'Outfit', sans-serif", fontSize: 18, fontWeight: 800, color: "#0A0A1A", lineHeight: 1 }}>{tierScore}</span>
                  <span style={{ fontSize: 8, color: "rgba(10,10,26,0.3)", marginTop: 1 }}>/ 100</span>
                </div>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 15, fontWeight: 700, color: "#0A0A1A", marginBottom: 4 }}>
                  {tierInfo.name} <Badge grade={tierGrade} small />
                </div>
                <div style={{ fontSize: 11, color: "rgba(10,10,26,0.4)", lineHeight: 1.4, marginTop: 4 }}>{tierInfo.question}</div>
              </div>
            </div>
            <div>
              {params.map(param => {
                const paramScore = Math.round(scores[param] || 0);
                const paramGrade = getGrade(paramScore);
                const barColors = { "badge-strong": "#0F2A8A", "badge-adequate": "#374151", "badge-weak": "#D97706", "badge-critical": "#DC2626" };
                return (
                  <div key={param} style={{ display: "flex", alignItems: "center", padding: "11px 18px", gap: 10, borderBottom: "1px solid rgba(10,10,26,0.04)" }}>
                    <span style={{ flex: 1, fontSize: 12.5, color: "rgba(10,10,26,0.6)", lineHeight: 1.3, minWidth: 0 }}>{PARAMETER_NAMES[param]}</span>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0, width: 140, justifyContent: "flex-end" }}>
                      <div style={{ width: 48, height: 3, background: "rgba(10,10,26,0.07)", borderRadius: 2, overflow: "hidden", flexShrink: 0 }}>
                        <div style={{ height: "100%", width: `${paramScore * 10}%`, background: barColors[paramGrade.class] || "#374151", borderRadius: 2 }} />
                      </div>
                      <span style={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, fontWeight: 700, color: "#0A0A1A", width: 28, textAlign: "right", flexShrink: 0 }}>{paramScore}/10</span>
                      <Badge grade={paramGrade} small />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      );
    })}
    
    {/* Grade Legend */}
    <div style={{ marginTop: 16, padding: "12px 16px", background: "rgba(10,10,26,0.03)", borderRadius: 8, display: "flex", justifyContent: "center", gap: 14, flexWrap: "wrap" }}>
      {[
        { label: "Strong", class: "badge-strong", range: "9-10" },
        { label: "Good", class: "badge-adequate", range: "7-8" },
        { label: "Weak", class: "badge-weak", range: "4-6" },
        { label: "Critical", class: "badge-critical", range: "0-3" }
      ].map(item => (
        <div key={item.label} style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <Badge grade={item} small />
          <span style={{ fontSize: 10, color: "rgba(10,10,26,0.3)" }}>{item.range}</span>
        </div>
      ))}
    </div>
    
    <div style={{ marginTop: 14 }}>
      <CTATeaser onTabChange={onTabChange} />
    </div>
  </div>
);

export default KeyMetricsTab;
